<section class="component-page">
  @if (router.url === '/catalog') {
    <app-introduction-box
      [title]="'menu.catalog'"
      [description]="'catalog.overview.introductionText'"
      [hidable]="true"
      [imageSrc]="'assets/images/catalog-introduction-box.png'"
      [imageAlt]="'Catalog'"
    >
      <ng-template let-hidden>
        <div class="catalog-search" [class.compact]="hidden">
          <mat-form-field appearance="outline" class="catalog-search-field" subscriptSizing="dynamic">
            <mat-label>{{ 'catalog.search.label' | transloco }}</mat-label>
            <mat-icon matPrefix>{{ isBpnlMode() ? 'fingerprint' : 'search' }}</mat-icon>
            <input matInput
                   [formControl]="searchControl"
                   [matAutocomplete]="orgAuto"
                   [placeholder]="'catalog.search.placeholder' | transloco"
                   [class.bpnl-mode]="isBpnlMode()"
                   (keydown.enter)="searchCatalog()"
                   autocomplete="off"
                   spellcheck="false" />

            @if ((loading$ | async) === true) {
              <mat-spinner matSuffix diameter="18" class="search-spinner"></mat-spinner>
            } @else if (searchControl.value) {
              <button matSuffix
                      mat-icon-button
                      class="search-clear-btn"
                      (click)="clearSearch()"
                      type="button">
                <mat-icon>close</mat-icon>
              </button>
            }

            <mat-autocomplete
              #orgAuto="matAutocomplete"
              [displayWith]="displayOrg"
              (optionSelected)="onOrgSelected($event)"
              class="catalog-org-autocomplete"
              [hideSingleSelectionIndicator]="true">

              <!-- Loading state -->
              @if (orgSearching()) {
                <mat-option disabled class="org-option org-option--loading">
                  <div class="org-option-loading">
                    <mat-spinner diameter="16"></mat-spinner>
                    <span>{{ 'catalog.search.searching' | transloco }}</span>
                  </div>
                </mat-option>
              }

              <!-- Results -->
              @for (org of orgResults(); track org.bpnl) {
                <mat-option [value]="org" class="org-option">
                  <div class="org-option-content">
                    <div class="org-option-main">
                      <span class="org-option-name">{{ org.organizationName }}</span>
                      <span class="org-option-bpnl">{{ org.bpnl }}</span>
                    </div>
                  </div>
                </mat-option>
              }

              <!-- No results -->
              @if (orgNoResults() && !orgSearching()) {
                <mat-option disabled class="org-option org-option--empty">
                  <div class="org-option-empty">
                    <mat-icon>search_off</mat-icon>
                    <span>{{ 'catalog.search.noResults' | transloco }}</span>
                  </div>
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </ng-template>
    </app-introduction-box>
  }
  <router-outlet></router-outlet>
</section>
